import React from 'react';
import '../styles/Project.css'; // Adjust the path based on your folder structure
import NavBar from './NavBar';
import TabsContainer from './TabsContainer';
import Footer from './Footer';

const ProjectOverview = () => {
    return (
        <div className="grid-container">
        <NavBar />
          <div className="project-title">
          <p>Projects</p>
          </div>
          <div className="project-intro">
            <p>Hi These are my featured projects that I have done through recent years</p>
          </div>
        
        <TabsContainer />
        <Footer/>
        </div>

    );
  };
  
  export default ProjectOverview;